module.exports = __webpack_public_path__ + "img/album15_06.843fdc46.jpg";